import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

const destinations = [
    {
        id: 1,
        title: "Skardu Blossom Season Tour",
        image: "/assets/img/tour/tour_2_1.jpg",
        rating: 4.9,
        duration: "5 Days / 4 Nights",
        link: "/contact",
    },
    {
        id: 2,
        title: "Hunza Cherry Blossom Tour",
        image: "/assets/img/tour/tour_2_2.jpg",
        rating: 4.9,
        duration: "5 Days / 4 Nights",
        link: "/contact",
    },
    {
        id: 3,
        title: "Hunza, Hopper & Naltar Valley",
        image: "/assets/img/tour/tour_2_3.jpg",
        rating: 4.8,
        duration: "5 Days / 4 Nights",
        link: "/contact",
    },
    {
        id: 4,
        title: "Fairy Meadows & Hunza Valley",
        image: "/assets/img/tour/tour_2_4.jpg",
        rating: 4.8,
        duration: "7 Days / 6 Nights",
        link: "/contact",
    },
    {
        id: 5,
        title: "Skardu Blossom Season Tour",
        image: "/assets/img/tour/tour_2_1.jpg",
        rating: 4.9,
        duration: "5 Days / 4 Nights",
        link: "/contact",
    },
    {
        id: 6,
        title: "Hunza Cherry Blossom Tour",
        image: "/assets/img/tour/tour_2_2.jpg",
        rating: 4.9,
        duration: "5 Days / 4 Nights",
        link: "/contact",
    },
    {
        id: 7,
        title: "Hunza, Hopper & Naltar Valley",
        image: "/assets/img/tour/tour_2_3.jpg",
        rating: 4.8,
        duration: "5 Days / 4 Nights",
        link: "/contact",
    },
    {
        id: 8,
        title: "Fairy Meadows & Hunza Valley",
        image: "/assets/img/tour/tour_2_4.jpg",
        rating: 4.8,
        duration: "7 Days / 6 Nights",
        link: "/contact",
    },

];
const sectionStyle = {
    position: "relative",
    overflow: "hidden",
    backgroundImage: "url('/assets/img/bg/tour_bg_2.jpg')",
    backgroundPosition: "top center",
    zIndex: 3,
    backgroundRepeat: "no-repeat",
    marginBottom: -348,
  };

function PopularDestination() {
    return (
        <section
            className="tour-sec2 position-relative overflow-hidden bg-top-center z-index-3 space-top"
            id="tour-sec"
            style={sectionStyle}
        >
            <div className="container">
                <div className="title-area mb-15 text-center">
                    <span className="sub-title">Best Adventure Tours in Pakistan</span>
                    <h2 className="sec-title">Popular Tours We Offer</h2>
                    <p className="tour-text">
                        From blossom season in Skardu to the scenic valleys of Hunza — discover Pakistan's most breathtaking destinations with Himolan Peak Adventures.
                    </p>
                </div>

                <div className="slider-area tour-slider">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        grabCursor={true}
                        speed={1000}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            480: { slidesPerView: 2 },
                            576: { slidesPerView: 2 },
                            1199: { slidesPerView: 3 },
                            1400: { slidesPerView: 4 },
                        }}
                        className="th-slider tourSlider2 has-shadow"
                    >
                        {destinations.map((destination) => (
                            <SwiperSlide key={destination.id}>
                                <div className="tour-card th-ani gsap-cursor">
                                    <div className="tour-card_img global-img">
                                        <img src={destination.image} alt={destination.title} />
                                    </div>
                                    <div className="tour-content">
                                        <h3 className="box-title">
                                            <Link to={destination.link}>{destination.title}</Link>
                                        </h3>
                                        <div className="tour-rating">
                                            <div className="star-rating" role="img" aria-label={`Rated ${destination.rating} out of 5`}>
                                                <span style={{ width: "100%" }}>
                                                    Rated <strong className="rating">5.00</strong> out of 5 based on{" "}
                                                    <span className="rating">{destination.rating}</span> ({destination.rating} Rating)
                                                </span>
                                            </div>
                                            <Link to={destination.link} className="woocommerce-review-link">
                                                (<span className="count">{destination.rating}</span> Rating)
                                            </Link>
                                        </div>
                                        <h4 className="tour-card_price">
                                            <span className="currency">{destination.duration}</span>
                                        </h4>
                                        <div className="tour-action">
                                            <span>
                                                <i className="fa-light fa-phone" /> Call for Price
                                            </span>
                                            <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style4">
                                                Book Now
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}

export default PopularDestination;

